import { useEffect } from "react";

const useFavicon = (faviconUrl: string | null | undefined): void => {
  useEffect(() => {
    if (!faviconUrl) return;

    // Remove existing favicon(s)
    const existingLinks = document.querySelectorAll("link[rel~='icon']");
    existingLinks.forEach((el) => el.parentNode?.removeChild(el));

    const link = document.createElement("link");
    link.rel = "icon";
    const version = __APP_VERSION__;
    const timestamp = new Date().getTime();
    link.href = `${faviconUrl}?v=${version}.${timestamp}`;
    document.head.appendChild(link);

    // Optional cleanup or reset
    return () => {
      link!.href = "/favicon.ico";
    };
  }, [faviconUrl]);
};

export default useFavicon;
